import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Layout from "./common/Layout";
import Back from "./common/Back";
import { useApi } from "../store/hooks";
import Loader from "./common/Loader";
import { GoToTheNextStep } from "./Step";
import { sleep } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const OpenbankingCallback = () => {
  const { t, i18n } = useTranslation();
  const { openbankingCallback } = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getWorkflow } = useApi();

  useEffect(() => {
    const fetchOpenBankingWithRetry = async () => {
      await sleep(5000);
      let status;
      let retryCount = 0;
      while (status !== "Succeeded" && status !== "Failed" && retryCount < 5) {
        await sleep(5000);
        const resp = await openbankingCallback();
        status = resp?.status;
        retryCount += 1;
      }
      if (status !== "Succeeded" && status !== "Failed") navigate("/Failure");
      else GoToTheNextStep(navigate, dispatch, getWorkflow);
    };
    fetchOpenBankingWithRetry();
  }, []);

  return (
    <Layout>
      <div className="az-title">{t("openbankingCallback.title")}</div>

      <Loader
        loading={true}
        title={t("initial.loader.title")}
        message={t("openbankingCallback.loading.message")}
      />

      <Back message={t("back.label")} />
    </Layout>
  );
};

export default OpenbankingCallback;
